import { css, html, LitElement, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { LayoutController } from "ui-common";
import { t, translate } from "../../translations/i18n";

import "ui-components/button/wow-button";

import "@phosphor-icons/webcomponents/PhPlus";
import "@phosphor-icons/webcomponents/PhEye";

@customElement("view-primary-buttons")
export class ViewPrimaryButtons extends LitElement {
  static override styles = css``;

  @property({ type: String })
  public primaryText?: string;

  @property({ type: String })
  public formId?: string;

  private layoutController = new LayoutController(this);

  handlePrimaryAction() {
    this.dispatchEvent(new CustomEvent("primary-click", { bubbles: true, composed: true }));
  }

  handleViewAction() {
    this.dispatchEvent(new CustomEvent("view-click", { bubbles: true, composed: true }));
  }

  override render() {
    return html`
      <div class="buttons">
        <wow-button variant="neutral" size="small" @click=${this.handleViewAction}>
          <ph-eye size="18" class="sort-icon"></ph-eye>
          ${this.layoutController.isTablet || this.layoutController.isMobile ? nothing : translate("menu.view")}
        </wow-button>
        <wow-button
          variant="primary"
          size="small"
          ?form=${this.formId}
          type=${this.formId ? "submit" : "button"}
          @click=${this.handlePrimaryAction}
        >
          <slot name="primaryIcon">
            <ph-plus size="18" class="sort-icon"></ph-plus>
          </slot>
          ${this.layoutController.isMobile ? nothing : html`${this.primaryText ?? t("menu.addNew")}`}
        </wow-button>
      </div>
    `;
  }
}
